// extracted by mini-css-extract-plugin
export default {"action":"Dropdown_action__ujOmj"};